import React, { useState, useEffect } from "react";
import "./Sub.css";
import arrowUp from "./images/arrow-down.png";
import arrowDown from "./images/arrow-up.png";

const Sub = ({ items, isArrowVisible, isFrame }) => {
  const [activeItem, setActiveItem] = useState(null);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    setActiveItem(null);
    setIsVisible(false);
    setTimeout(() => {
      setIsVisible(true);
    }, 250);
  }, [items]);

  useEffect(() => {
    setActiveItem(null);
    setIsVisible(!isFrame);
  }, [isFrame]);

  const handleItemClick = (item, index) => {
    item.onClick();
    if (activeItem === index) {
      setActiveItem(null);
    } else {
      setActiveItem(index);
    }
  };

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  return (
    <div>
      <div
        className={`sub-wrapper ${isVisible ? "sub-visible" : "sub-hidden"}`}
      >
        <button className="sub-prev-btn">«</button>
        <div className="sub-scroll-container">
          {items.map((item, index) => (
            <div
              key={index}
              onClick={() => handleItemClick(item, index)}
              className={`menu-item1 ${activeItem === index ? "active" : ""}`}
            >
              {item.text}
            </div>
          ))}
        </div>
        <button className="sub-next-btn">»</button>
      </div>
      {isArrowVisible && (
        <>
          <div
            className={`buttonexpand ${!isVisible ? "contraer" : ""}`}
            onClick={toggleVisibility}
          >
            <img
              src={isVisible ? arrowUp : arrowDown}
              alt={isVisible ? "Contraer" : "Expandir"}
              className="imgarrow"
            />
          </div>
          <div
            className={`buttonexpand2 ${!isVisible ? "contraer" : ""}`}
            onClick={toggleVisibility}
          >
            <img
              src={isVisible ? arrowUp : arrowDown}
              alt={isVisible ? "Contraer" : "Expandir"}
              className="imgarrow"
            />
          </div>
        </>
      )}
    </div>
  );
};

export default Sub;
